import React from 'react'

import { ModalBox, useModalContext } from '@fourthwall/components'

import { LiveStreamKeys } from '../LiveStreamKeys/LiveStreamKeys'

type Props = {
  rtmpsUrl?: string
  srtUrl?: string
  streamKey?: string
}

export const LiveStreamKeysModal = ({ rtmpsUrl, srtUrl, streamKey }: Props) => {
  const { close } = useModalContext()

  return (
    <ModalBox title="Stream URL and key" onClose={close}>
      <LiveStreamKeys rtmpsUrl={rtmpsUrl || ''} srtUrl={srtUrl || ''} streamKey={streamKey || ''} />
    </ModalBox>
  )
}
